<sui-switch (click)="clickAction(params)" [checked]="status"></sui-switch>
